<template>
  <div class="potion-container col-12">
    <div class="row">
      <div class="col-8 text-left">
        <div class="potion-title-container">
          <h6 class="potion-title">Attack</h6>
        </div>

        <img loading="lazy" sizes="100%, 100%" class="img-fluid" title="Attack boost" alt="Attack boost" src="/static/images/icons/attack.png">
        <span class="boost-amount">+{{boosts.attack}}</span>
      </div>
      <div class="col-4">
        <InventorySlot :id="selectedPotions.attack.id" :selected-item="selectedPotions.attack"
                       @update="potionUpdate" :itemSlot="'attack'"
                       :items="potions.attack"></InventorySlot>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-8 text-left">
        <div class="potion-title-container">
          <h6 class="potion-title">Strength</h6>
        </div>

        <img loading="lazy" sizes="100%, 100%" class="img-fluid" title="Strength boost" alt="Strength boost" src="/static/images/icons/strength.png">
        <span class="boost-amount">+{{boosts.strength}}</span>
      </div>
      <div class="col-4">
        <InventorySlot :id="selectedPotions.strength.id" :selected-item="selectedPotions.strength"
                       @update="potionUpdate" :itemSlot="'strength'"
                       :items="potions.strength"></InventorySlot>
      </div>
    </div>


    <div class="row mt-3">
      <div class="col-8 text-left">
        <div class="potion-title-container">
          <h6 class="potion-title">Ranged</h6>
        </div>

        <img loading="lazy" sizes="100%, 100%" class="img-fluid" title="Ranged boost" alt="Ranged boost" src="/static/images/icons/ranged.png">
        <span class="boost-amount">+{{boosts.ranged}}</span>
      </div>
      <div class="col-4">
        <InventorySlot :id="selectedPotions.ranged.id" :selected-item="selectedPotions.ranged"
                       @update="potionUpdate" :itemSlot="'ranged'"
                       :items="potions.ranged"></InventorySlot>
      </div>
    </div>


    <div class="row mt-3">
      <div class="col-8 text-left">
        <div class="potion-title-container">
          <h6 class="potion-title">Magic</h6>
        </div>

        <img loading="lazy" sizes="100%, 100%" class="img-fluid" title="Magic boost" alt="Magic boost" src="/static/images/icons/magic.png">
        <span class="boost-amount">+{{boosts.magic}}</span>
      </div>
      <div class="col-4">
        <InventorySlot :id="selectedPotions.magic.id" :selected-item="selectedPotions.magic"
                       @update="potionUpdate" :itemSlot="'magic'"
                       :items="potions.magic"></InventorySlot>
      </div>
    </div>
  </div>
</template>

<script>
  import ItemSlot from "./ItemSlot";
  import InventorySlot from "./InventorySlot";
  import PlayerStat from "../PlayerStat";

  export default {
    name: "PotionContainer",
    components: {PlayerStat, InventorySlot, ItemSlot},
    props: {
      selectedPotions: {
        type: Object,
        default() {
          return require('@/assets/data/potions/default.json')
        }
      },
      boosts: {
        type: Object
      },
      player: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        potions: {
          attack: require('@/assets/data/potions/attack.json'),
          strength: require('@/assets/data/potions/strength.json'),
          ranged: require('@/assets/data/potions/ranged.json'),
          magic: require('@/assets/data/potions/magic.json'),
        }
      }
    },
    methods: {
      potionUpdate: function (itemSlot, potion) {
        this.selectedPotions[itemSlot] = potion;
        this.$emit('update');
      },
    }
  }
</script>

<style scoped>
  .boost-amount {
    line-height: 25px;
    font-weight: bold;
    color: green;
  }

  .potion-title {
    padding-bottom: 5px;
    text-align: left;
    font-weight: bold;
    color: #dbcba3;
    border-bottom: 2px solid #dbcba3;

  }
</style>



// WEBPACK FOOTER //
// src/components/gear-selector/PotionContainer.vue